'use client'

import * as React from 'react'
import { captureAffiliateIdFromUrl } from '@repo/affiliate-id'

/**
 * Captures the affiliate ref from the current URL on mount and records the
 * AffiliateWP visit. Handles both URL forms:
 *
 * - `?affwp_ref=<id>` — query param (used after the Next.js middleware rewrites
 *   pretty `/ref/<id>` suffix URLs for apps without a matching route, e.g.
 *   `freemode-landing-pages`)
 * - `/ref/<id>` — path segment (used in apps like `apps/web` that serve a
 *   catch-all and keep the URL as-is)
 *
 * `captureAffiliateIdFromUrl` also writes the ref to `localStorage` so payment
 * mutations on cross-domain apps (e.g. `freemode.ai`) can forward it explicitly.
 */
export function AffiliateCapture() {
  React.useEffect(() => {
    let active = true

    const affiliateId = captureAffiliateIdFromUrl()

    if (affiliateId) {
      import('@repo/affiliate-tracking')
        .then(({ captureReferral }) => (active ? captureReferral(affiliateId) : undefined))
        .catch(() => null)
    }

    return () => {
      active = false
    }
  }, [])

  return null
}
